import { fn } from '@storybook/test';

import type { Meta, StoryFn } from '@storybook/react';
import type { CheckboxButtonProps } from './CheckboxButton';

import { CheckboxButton } from './CheckboxButton';

const codeString =
  '<CheckboxButton label={} value={} isChecked={} variant={} disabled={} notValid={} onSetValue={} key={} />';

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/CheckboxButton',
  component: CheckboxButton,
  argTypes: {
    label: {
      control: 'text',
    },
    value: {
      control: 'string',
    },
    isChecked: {
      control: 'boolean',
    },
    variant: {
      options: ['single', 'start', 'middle', 'end'],
      control: 'radio',
    },
    disabled: {
      control: 'boolean',
    },
    notValid: {
      control: 'boolean',
    },
    onSetValue: {
      table: {
        disable: true,
      },
    },
  },
  parameters: {
    inspectComponent: CheckboxButton,
    codeString: codeString,
  },
} as Meta<CheckboxButtonProps>;

const Template: StoryFn<CheckboxButtonProps> = (args) => <CheckboxButton {...args} />;

export const CheckboxButtonExample = Template.bind({});
CheckboxButtonExample.args = {
  label: '1.2',
  value: '1.2',
  variant: 'single',
  onSetValue: fn(),
};
